import { AuthFetchWithResponse } from 'src/Types/api'
import { ApiResult } from 'src/Libs/api'
import { StatusCodes } from '@e3dc-react/shell/Libs'
import { AuthFetchError } from '@e3dc-react/shell/Types/api'
import { handleFetchError } from 'src/Libs/api/utils'
import { DynamicTariffSettingsDto } from '../dto'
import { DynamicTariffSettingsModel } from '../model'
import { dynamicTariffSettingsDtoToModelTransformer } from '../transformer'

/**
 * Fetch dynamic tariff settings for a specific installation.
 */
export const fetchDynamicTariffSettings = async (
  installationId: string | undefined,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<DynamicTariffSettingsModel, AuthFetchError | Error>> => {
  if (!installationId) return new ApiResult<DynamicTariffSettingsModel, AuthFetchError | Error>(null)

  try {
    const response = await authFetch<DynamicTariffSettingsDto>({
      path: `tariffs/${installationId}/setting`,
      method: 'GET',
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
    })

    if (response.status === StatusCodes.OK) {
      const dataModel = dynamicTariffSettingsDtoToModelTransformer(response.data)
      return new ApiResult<DynamicTariffSettingsModel, AuthFetchError | Error>(dataModel)
    }
    return new ApiResult<DynamicTariffSettingsModel, AuthFetchError | Error>(null)
  } catch (error) {
    return handleFetchError<DynamicTariffSettingsModel>(error)
  }
}

/**
 * create dynamic tariff settings for a specific installation.
 */
export const createDynamicTariffSettings = async (
  installationId: string | undefined,
  data: DynamicTariffSettingsDto,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<boolean, AuthFetchError | Error>> => {
  if (!installationId) return new ApiResult<boolean, AuthFetchError | Error>(null, true)

  try {
    const response = await authFetch<DynamicTariffSettingsModel>({
      path: `tariffs/${installationId}/setting`,
      method: 'POST',
      payload: data,
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
    })

    if (response.status === StatusCodes.NO_CONTENT) {
      return new ApiResult<boolean, AuthFetchError | Error>(true)
    }
    return new ApiResult<boolean, AuthFetchError | Error>(false, true)
  } catch (error) {
    return handleFetchError<boolean>(error)
  }
}
